module.exports = __webpack_public_path__ + "static/media/applestore.5f9bbfeb.svg";